import { Component, inject } from '@angular/core';
import {
	VbLxpPanelComponent,
	RaceSessionService,
	TimingTowerFullComponent,
	TimingTowerService,
	VbLxpMapComponent,
} from '@vbrick/vb-lxp-lib';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-full-timing.component',
	imports: [VbLxpPanelComponent, TimingTowerFullComponent, VbLxpMapComponent],
	templateUrl: './full-timing.component.html',
	styleUrl: './full-timing.component.css',
})
export class FullTimingComponent {
	public timingTowerService = inject(TimingTowerService);
	public raceSessionService = inject(RaceSessionService);
	public selectedClasses = toSignal(this.raceSessionService.selectedClasses$, { initialValue: [] });

	public openFullMapPage() {
		const currentParams = new URLSearchParams(window.location.search).toString();
		const base = new URL('map-popout', document.baseURI).toString();
		const url = currentParams ? `${base}?${currentParams}` : base;
		const width = 1280;
		const height = 720;
		window.open(url, '_blank', `width=${width},height=${height},resizable=yes`);
	}
}
